export const shouldRunSilentStaleEconomicsRepair = ({
  enabled = true,
  venueId,
  staleRecipeIds = [],
  hasRepairSession = false,
} = {}) => {
  if (!enabled || !venueId || hasRepairSession) {
    return false
  }

  return staleRecipeIds.length > 0
}
